import { render, staticRenderFns } from "./postFeatureImageBlock.vue?vue&type=template&id=4cd4ecb9&scoped=true"
import script from "./postFeatureImageBlock.vue?vue&type=script&lang=js"
export * from "./postFeatureImageBlock.vue?vue&type=script&lang=js"
import style0 from "./postFeatureImageBlock.vue?vue&type=style&index=0&id=4cd4ecb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd4ecb9",
  null
  
)

export default component.exports